'use client';

import React from 'react';
import styled from 'styled-components';

interface URLInputSectionProps {
  url: string;
  onUrlChange: (url: string) => void;
  friendlyName: string;
  onFriendlyNameChange: (name: string) => void;
  className?: string;
}

const Container = styled.div`
  margin-bottom: 32px;
`;

const SectionTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 16px 0;
`;

const URLInput = styled.input`
  width: 100%;
  padding: 14px 16px;
  background: #1f2937;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 16px;
  margin-bottom: 16px;
  
  &::placeholder {
    color: #6b7280;
  }

  &:focus {
    outline: none;
    border-color: #5B47E5;
    box-shadow: 0 0 0 3px rgba(91, 71, 229, 0.1);
  }
`;

const FriendlyNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FriendlyNameLabel = styled.span`
  font-size: 14px;
  color: #9ca3af;
`;

const FriendlyNameValue = styled.span`
  font-size: 14px;
  color: #ffffff;
`;

const RenameButton = styled.button`
  background: transparent;
  border: none;
  color: #9ca3af;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  
  &:hover {
    background: #374151;
    color: #ffffff;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const URLInputSection: React.FC<URLInputSectionProps> = ({
  url,
  onUrlChange,
  friendlyName,
  onFriendlyNameChange,
  className,
}) => {
  const [isEditingName, setIsEditingName] = React.useState(false);

  return (
    <Container className={className}>
      <SectionTitle>URL to monitor</SectionTitle>
      <URLInput
        type="url"
        value={url}
        onChange={(e) => onUrlChange(e.target.value)}
        placeholder="https://www.example.com/"
      />
      
      <FriendlyNameWrapper>
        <FriendlyNameLabel>Friendly name:</FriendlyNameLabel>
        {isEditingName ? (
          <URLInput
            type="text"
            value={friendlyName}
            onChange={(e) => onFriendlyNameChange(e.target.value)}
            onBlur={() => setIsEditingName(false)}
            autoFocus
            style={{ width: 'auto', flex: 1, margin: 0 }}
          />
        ) : (
          <>
            <FriendlyNameValue>{friendlyName}</FriendlyNameValue>
            <RenameButton onClick={() => setIsEditingName(true)}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
              </svg>
              Rename
            </RenameButton>
          </>
        )}
      </FriendlyNameWrapper>
    </Container>
  );
};

export default URLInputSection;

